import { useState, type FormEvent } from 'react';
import { auth } from '../lib/api';

export function SignIn() {
  const [email, setEmail] = useState('');
  const [challengeId, setChallengeId] = useState<string | null>(null);
  const [code, setCode] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  async function start(e: FormEvent) {
    e.preventDefault();
    setBusy(true); setError('');
    try { setChallengeId((await auth.start(email)).challengeId); } catch (err) { setError((err as Error).message); } finally { setBusy(false); }
  }
  async function verify(e: FormEvent) {
    e.preventDefault();
    setBusy(true); setError('');
    try { await auth.verify(challengeId!, code); } catch (err) { setError((err as Error).message); } finally { setBusy(false); }
  }

  return (
    <div className="center">
      <div className="card narrow">
        <h1>Knock Knock Platform</h1>
        {!challengeId ? (
          <form onSubmit={start} className="stack">
            <p className="muted">Staff sign-in. We'll email you a six-digit code.</p>
            <div><label htmlFor="email">Email</label><input id="email" type="email" autoComplete="email" required autoFocus value={email} onChange={(e) => setEmail(e.target.value)} /></div>
            <button className="primary" disabled={busy}>Send code</button>
            {error && <p className="err">{error}</p>}
          </form>
        ) : (
          <form onSubmit={verify} className="stack">
            <p className="muted">Enter the code we sent to <b>{email}</b>. If you're not on the staff list, no code arrives.</p>
            <div><label htmlFor="code">Code</label><input id="code" className="code-input" inputMode="numeric" pattern="[0-9]{6}" maxLength={6} autoComplete="one-time-code" required autoFocus value={code} onChange={(e) => setCode(e.target.value)} /></div>
            <button className="primary" disabled={busy}>Sign in</button>
            <button type="button" className="link" onClick={() => { setChallengeId(null); setCode(''); }}>Use a different email</button>
            {error && <p className="err">{error}</p>}
          </form>
        )}
      </div>
    </div>
  );
}
